import {
  PROFILE_ASYNC_CALL_START,
  PROFILE_ASYNC_CALL_END,
  FETCH_USER_PROFILE_SUCCESS,
  PROFILE_UPDATE_SUCCESS,
  EMAIL_CHANGE_SUCCESS,
  PROFILE_MINOR_ASYNC_CALL_START,
  PROFILE_MINOR_ASYNC_CALL_END,
} from '../actions/actions'

import {
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST,
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS,
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE,
} from '../actions/actions'

export default function profile(state = {}, action) {
  switch (action.type) {
    case PROFILE_ASYNC_CALL_START:
      return { ...state, aSyncCall: true }

    case PROFILE_ASYNC_CALL_END:
      return { ...state, aSyncCall: false }

    case PROFILE_MINOR_ASYNC_CALL_START:
      return { ...state, minorAsyncCall: true }

    case PROFILE_MINOR_ASYNC_CALL_END:
      return { ...state, minorAsyncCall: false }

    case FETCH_USER_PROFILE_SUCCESS:
      return { ...state, userInfo: action.userInfo }

    case PROFILE_UPDATE_SUCCESS:
      return { ...state, userInfo: action.userInfo }

    case EMAIL_CHANGE_SUCCESS:
      return {
        ...state,
        userInfo: Object.assign({}, state.userInfo, { email: action.newEmail }),
      }

    case 'MANAGER_TOGGLE_SCHOOL_VERIFICATION_SUCCESS':
      const changedSchool = action.school
      return { ...state, userInfo: changedSchool }


    case FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST:
      return { ...state, document_groups: [], isLoading: true }

    case FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS:
      return { ...state, document_groups: action.groups, isLoading: false }

    case FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE:
      return { ...state, document_groups: [], isLoading: true }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.js